import { useSplitEnabled } from '@buffer-mono/features'

import { InsightsAnnouncementModalDialog } from './InsightsAnnouncementModalDialog'

import type { JSX } from 'react'

/**
 * Split-gated wrapper for the Insights launch announcement dialog.
 *
 * Renders nothing until the `insights-announcement-modal` split has loaded and
 * is enabled. The dialog itself handles one-time dismissal, audience targeting,
 * and the personalized-vs-fallback variant selection.
 */
export function InsightsAnnouncementModal(): JSX.Element | null {
  const { isEnabled, isReady } = useSplitEnabled('insights-announcement-modal')

  if (!isReady || !isEnabled) {
    return null
  }

  return <InsightsAnnouncementModalDialog />
}
